export class RelatedUserRole {
    constructor(value?: any) {
        this.userRole_Id = value.id;
        this.name = value.name;
    }
    userRole_Id: string;
    name: string;
}
